import { createTheme } from "@mui/material/styles";

const palette = createTheme({
  palette: {
    primary: {
      // Dr. Lam website inspired colors
      main: "#15749D", // Deep green
      light: "#4CAF50", // Light green
      dark: "#1B5E20", // Dark green
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#2E7D32", // Deep green
      light: "#4CAF50", // Light green
      dark: "#1B5E20", // Dark green
      contrastText: "#ffffff",
    },
    success: {
      main: "#2E7D32", // Green for success states
      light: "#4CAF50",
      dark: "#1B5E20",
    },
    warning: {
      main: "#FF6F00", // Orange for warnings
      light: "#FF9800",
      dark: "#E65100",
    },
    info: {
      main: "#1976D2", // Blue for info
      light: "#42A5F5",
      dark: "#1565C0",
    },
    error: {
      main: "#D32F2F", // Red for errors
      light: "#EF5350",
      dark: "#C62828",
    },
    // secondary: {
    //   // light: "#0066ff",
    //   // dark: will be calculated from palette.secondary.main,
    //   // contrastText: "#ffcc00",
    // },
    // Provide every color token (light, main, dark, and contrastText) when using
    // custom colors for props in Material UI's components.
    // Then you will be able to use it like this: `<Button color="custom">`
    // (For TypeScript, you need to add module augmentation for the `custom` value)
    // custom: {
    //   light: "#ffa726",
    //   main: "#f57c00",
    //   dark: "#ef6c00",
    //   contrastText: "rgba(0, 0, 0, 0.87)",
    // },

    drawerColor: {
      // main: "#0D1E37",
      main: "#0E4A6B",
    },
    white: {
      main: "#ffffff",
    },

    bgColor: {
      main: "#FFF6F6",
    },
    blue: {
      main: "#0085FF",
    },
    yellow: {
      main: "#A19B00",
      secondary: "#FF9415",
      tertiary: "#FF9B25",
    },
    purple: {
      main: "#5D59FA",
    },
    green: {
      main: "#00710B",
    },
    // shivam #FF9B25

    addMenuItemColor: {
      light: "rgba(217, 217, 217, 0.44)",
      light2: "rgba(210, 210, 210, 0.33)",
      light3: "rgba(248, 215, 177, 0.89)",
    },
    dataGrid: {
      header: "#FDE5EC",
    },
    grey: {
      main: "#7B7B7B",
      primary: "#8B8B8B",
      secondary: "#F5F5F5",
      tertiary: "#393939",
      light: "rgba(97, 97, 97, 0.11)",
      light2: "rgba(97, 97, 97, 0.29)",
      cloudyGrey: "#686868",
      midGrey: "#616161",
      lightGrey: "#DFDFDF",
    },
    black: {
      main: "00000",
    },

    // Dr. Lam inspired additional colors
    natural: {
      main: "#8D6E63", // Natural brown
      light: "#A1887F",
      dark: "#5D4037",
    },
    cream: {
      main: "#FFF8E1", // Cream background
      light: "#FFFEF7",
      dark: "#F5F5DC",
    },
    earth: {
      main: "#6D4C41", // Earth tone
      light: "#8D6E63",
      dark: "#4E342E",
    },

    // shivam

    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});

export default palette;
